import { InformationCircleIcon } from '@heroicons/react/outline';

const MentorModeBanner = () => (
  <div className="w-full rounded-lg border border-blue-200 bg-blue-50 p-4 text-blue-900">
    <div className="flex items-start gap-3">
      <InformationCircleIcon className="h-6 w-6 flex-shrink-0 text-tttDefault" />
      <div>
        <p className="font-medium">Mentor Mode</p>
        <p className="text-sm">
          Quizzes taken from this account are for practice or preview only. They
          will not complete a Thinker&apos;s assignment or update their
          progress. Thinkers must sign in to their own account to complete
          assignments.
        </p>
      </div>
    </div>
  </div>
);

export default MentorModeBanner;
